export const backendFrTranslations = {
  'cost center belongs to another organisation':
    'Le centre de coûts appartient à une autre organisation',
}
